import { useEffect, useState } from 'react';

/**
 * Returns a debounced copy of `value` that only settles after `delayMs` elapses with no further change.
 * Intended for server-side combobox filtering: pass the immediate input value in and feed the debounced
 * output into the query so each keystroke does not fire a request.
 */
export const useDebouncedValue = <T>(value: T, delayMs = 250): T => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const timeout = setTimeout(() => setDebouncedValue(value), delayMs);
    return () => clearTimeout(timeout);
  }, [value, delayMs]);

  return debouncedValue;
};
